import { createAjaxAction } from '../../Common/_actions/AjaxAction';
import { createAction } from '../../Common/_actions/Action';
import { Toast } from '../../UIData/_actions/UIDataActions';

export enum UserDataActionType {
	EditUserLoggedIn			= "EDIT_USER_LOGGEDIN",
	EditUserValidated			= "EDIT_USER_VALIDATED",
	EditUserFetched				= "EDIT_USER_FETCHED",
	SetPaginationData			= "PAGINATION_SET_DATA",
	InvalidatePaginationData	= "PAGINATION_INVALIDATE_DATA",
}

export const EditUserLoggedIn = (status:boolean) => createAction(UserDataActionType.EditUserLoggedIn, {
	status: status
});

export const EditUserValidated = (valid:boolean) => createAction(UserDataActionType.EditUserValidated, {
	valid: valid
});

export const EditUserFetched = (fetched:boolean) => createAction(UserDataActionType.EditUserFetched, {
	fetched: fetched
});

export const SetPaginationData = (data:object) => createAction(UserDataActionType.SetPaginationData, {
	data: data
})

export const InvalidatePaginationData = (name:string) => createAction(UserDataActionType.InvalidatePaginationData, {
	name: name
});

export const FetchPaginationItems = (data:FormData, dataType:string) => createAjaxAction({
	url: "ajax/user/" + dataType + "/fetch",
	method: "GET",
	data: data,
	limit: 150,
	abortPrevious: true,
	onSuccess: (response, dispatch) => {
		dispatch(SetPaginationData(response.data));
	},
	onFailure: (response, dispatch) => {
		dispatch(Toast('Something went wrong!'));
	}
});

export const RenamePaginationItem = (data:FormData, dataType:string) => createAjaxAction({
	url: "ajax/user/" + dataType + "/rename",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		dispatch(InvalidatePaginationData(dataType));
	},
	onFailure: (response, dispatch) => {
		dispatch(Toast('Something went wrong!'));
	}
});

export const DeletePaginationItem = (data:FormData, dataType:string) => createAjaxAction({
	url: "ajax/user/" + dataType + "/delete",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		dispatch(InvalidatePaginationData(dataType));
	},
	onFailure: (response, dispatch) => {
		dispatch(Toast('Something went wrong!'));
	}
});

export type UserDataAction =
	ReturnType<typeof EditUserLoggedIn>			|
	ReturnType<typeof EditUserValidated>		|
	ReturnType<typeof EditUserFetched>			|
	ReturnType<typeof SetPaginationData>		|
	ReturnType<typeof InvalidatePaginationData>